export type Criteria = Record<string, unknown>

export const filterEmptyDetailSearchValues = (values: Criteria = {}): Criteria => {
    return Object.fromEntries(Object.entries(values).filter(([, value]) => value !== null && value !== ''))
}
